export default __webpack_public_path__ + "static/realWorldImg1-4d021bce2c1a4e0d89c7ea8320884e32.png";